import React from 'react';

import { enum as popupCustomContentIds } from '../../../../../../../../../enums/popup-custom-content-ids';

import ExamplePopup from './custom-popups/example-popup';
import BirthdayAndCityPopup from './custom-popups/birthday-and-city-popup';

function renderCustomPopup(popup, props) {
	const Popup = getPopupComponent(popup.content.id);

	return (
		<Popup popup={popup} {...props} key={popup.id} />
	);
}

function getPopupComponent(contentId) {
	switch (contentId) {
		case popupCustomContentIds['test']:
			return ExamplePopup;
		case popupCustomContentIds['birthday-and-city']:
			return BirthdayAndCityPopup;
	}
}

export default renderCustomPopup;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/popup-window/popup/render-popup/render-custom-popup/index.js